import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { AnalyticsService } from '@app/core/_services/analytics.service'
import { DialogService } from '@app/core/_services/dialog.service'
import { MessageModule } from 'primeng/message'

const BANNER_NAME = 'Group Meeting: Beta Live Host Announcement'
const BANNER_SOURCE = 'groupMeetingBetaLiveHostAnnouncementBanner'

@Component({
    selector: 'fm-group-meeting-beta-live-host-announcement-banner',
    standalone: true,
    imports: [MessageModule],
    templateUrl: './group-meeting-beta-live-host-announcement-banner.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupMeetingBetaLiveHostAnnouncementBannerComponent implements OnInit {
    readonly pMessageScopedToken = {
        root: {
            borderRadius: '0',
            borderWidth: '0',
        },
        content: {
            gap: '0',
            padding: '0',
        },
        colorScheme: {
            dark: {
                info: {
                    background: '{blue.200}',
                    borderColor: '{blue.200}',
                    color: '{surface.700}',
                    shadow: 'none',
                },
            },
            light: {
                info: {
                    background: '{blue.200}',
                    borderColor: '{blue.200}',
                    color: '{surface.700}',
                    shadow: 'none',
                },
            },
        },
    }

    constructor(
        private analyticsService: AnalyticsService,
        private dialogService: DialogService,
    ) {}

    ngOnInit(): void {
        this.analyticsService.logViewedBannerEvent(BANNER_NAME, { source: BANNER_SOURCE })
    }

    onClickLearnMore(): void {
        this.analyticsService.logGroupMeetingClick('learnMoreAboutGroupMeetings', BANNER_SOURCE)
        this.dialogService.openGroupMeetingBetaLiveHostAnnouncementDialog()
    }
}
